module.exports = __webpack_public_path__ + "img/icon_calendar.9ec05394.svg";